import { Text, TextTypography } from '../Text/Text';
import { Box, Slider } from '@material-ui/core';
import React, { useCallback } from 'react';
import i18n from '../../../i18n';

export interface GalleryDialogZoomProps {
    zoom: number;
    onZoomChange: (value: number) => void;
}

export const GalleryDialogZoom = (props: GalleryDialogZoomProps) => {
    const { zoom, onZoomChange } = props;
    const { t } = i18n.useTranslation();

    const handleZoomChange = useCallback(
        (_, value: number | number[]) => {
            const newZoom = Array.isArray(value) ? value[0] : value;
            if (newZoom !== zoom) {
                onZoomChange(newZoom);
            }
        },
        [onZoomChange, zoom],
    );

    return (
        <Box display="flex" alignItems="center" m={2}>
            <Box flex="0 0 auto" mr={2} mb={0.75}>
                <Text typography={TextTypography.BODY}> {t('common:gallery.zoom')}</Text>
            </Box>
            <Box flex="1">
                <Slider disabled={false} value={zoom} min={0.1} max={1} step={0.1} onChange={handleZoomChange} />
            </Box>
        </Box>
    );
};
